/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Save_TitleInputs */



/**
* | output |
* | --- |
* | "Save Subtitle Export Preset" |
*
* @param {Subtitle_Export_Preset_Save_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_save_title = /** @type {((inputs?: Subtitle_Export_Preset_Save_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Save_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préréglage d'exportation des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel-Exportvoreinstellung speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva preimpostazione esportazione sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить настройки экспорта субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar ajuste preestablecido de exportación de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存字幕导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕エクスポートプリセットを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक निर्यात प्रीसेट सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar predefinição de exportação de legenda")
	return /** @type {LocalizedString} */ ("Save Subtitle Export Preset")
});